import { render, staticRenderFns } from "./import-clients-modal.vue?vue&type=template&id=561d6e60"
import script from "./import-clients-modal.vue?vue&type=script&lang=js"
export * from "./import-clients-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports